import { takeLatest, put, throttle, select, all } from 'redux-saga/effects';
import {
  LOAD_COMMISSION_PAID_INDEX,
  loadCommissionPaidIndexFailure,
  setCommissionPaidIndex,
  CHANGE_PAGINATOR_PAGE,
  DOWNLOAD_CSV,
  SET_STATUS_FILTER,
  SET_CALENDAR_SAGA,
  CLEAR_CALENDAR_FILTER,
  setPaginatorTotal,
  SET_PER_PAGE_FILTER,
  ORDER_BY_AMOUNT
} from './reducer';
import { getRequest, handleSagaError } from '../../../utilities/requests';
import {
  downloadCsv,
  calculatePagination,
  orderBy
} from '../../../utilities/misc';
import { handleLoadReferralCryptoWallets } from '../../Account/CryptoWallets/sagas';
import { handleLoadReferralBankDetails } from '../../Account/BankAccount/sagas';

export function* loadCommissionPaidIndexSaga() {
  yield takeLatest(
    [
      LOAD_COMMISSION_PAID_INDEX,
      CHANGE_PAGINATOR_PAGE,
      SET_STATUS_FILTER,
      SET_PER_PAGE_FILTER,
      SET_CALENDAR_SAGA,
      CLEAR_CALENDAR_FILTER,
      ORDER_BY_AMOUNT
    ],
    handleCommissionPaidIndex
  );
}

export function* downloadCommissionPaidIndexCsvSaga() {
  yield throttle(5000, DOWNLOAD_CSV, handleCommissionPaidIndex);
}

function* handleCommissionPaidIndex(action) {
  try {
    const currentPage = yield select(
      state => state.commissionPayouts.commissionPaid.index.currentPage
    );
    const perPage = yield select(
      state => state.commissionPayouts.commissionPaid.index.perPageFilter
    );
    const calendarStart = yield select(
      state => state.commissionPayouts.commissionPaid.index.calendarStart
    );
    const calendarEnd = yield select(
      state => state.commissionPayouts.commissionPaid.index.calendarEnd
    );
    const orderByState = yield select(
      state => state.commissionPayouts.commissionPaid.index.orderByState
    );
    const orderByType = yield select(
      state => state.commissionPayouts.commissionPaid.index.orderByType
    );
    const status = yield select(
      state => state.commissionPayouts.commissionPaid.index.statusFilter
    );
    const config = {
      page: currentPage,
      per_page: perPage,
      status
    };

    const orderConfig = orderBy(orderByType, orderByState);
    Object.assign(config, { ...orderConfig });

    if (calendarEnd) {
      config.start_date = calendarStart.format('YY/MM/DD');
      config.end_date = calendarEnd.format('YY/MM/DD');
    }

    if (action.type === DOWNLOAD_CSV) {
      yield downloadCsv(action.path, null, config);
    } else {
      yield all([
        handleLoadCommissionPaid(config, perPage),
        handleLoadReferralCryptoWallets(),
        handleLoadReferralBankDetails()
      ]);
    }
  } catch (error) {
    yield handleSagaError(
      error,
      'There was an error loading commission payout history.',
      loadCommissionPaidIndexFailure
    );
  }
}

function* handleLoadCommissionPaid(config, perPage) {
  const url = '/commission_payouts';

  const response = yield getRequest(url, config);
  yield calculatePagination(
    response.data.commission_payouts_count,
    perPage,
    setPaginatorTotal
  );
  yield put(setCommissionPaidIndex(response.data));
}
